<template>
  <div class="project" style="height: 100%;">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'project',
}
</script>
<style>
.project {
  /*margin-top: 70px;*/
}
</style>
